module.exports = __webpack_public_path__ + "img/h-page4-61.328d1a4f.png";